import { defaultHeatmapImage } from 'lib/helpers';
import get from 'lodash.get';
// import {SplitTestInterface} from "./abtest.interface";

export function getCoverPhoto(splitTest: any): string {
  const input = get(splitTest, 'inputFile[0].images[1].image', defaultHeatmapImage);
  return get(splitTest, 'outputFile[0][1].image', input);
}
